<template>
  <div>
    <div
      class="mb-5 font-roboto text-[26px] font-semibold leading-8 tracking-wider"
    >
      Рекомендации
    </div>

    <BaseTheSortTags
      v-if="false"
      v-model="activeTab"
      :tabs="sortOptions"
      class="mb-5"
      @change="handleTabChange"
    />

    <!-- <div
      v-if="wikisData.length"
      class="grid w-full grid-cols-1 gap-5 md:grid-cols-2 2xl:grid-cols-3"
    >
      <WikiCard
        v-for="wiki in wikisData"
        :key="wiki.id"
        :data="wiki"
        disable-label
      />
    </div> -->

    <div v-if="wikisData.length" class="mt-6 grid grid-cols-1 md:grid-cols-3">
      <NuxtLink
        v-for="wiki in wikisData"
        :key="wiki.id"
        :to="`/encyclopedia/${wiki.slug}`"
        class="group flex flex-col border-b border-[#F9F0F1] p-5 transition-colors hover:bg-new-gray-light/10"
      >
        <div class="flex items-center justify-between gap-2">
          <div
            class="text-gray-800 cursor-pointer text-[14px] font-bold uppercase tracking-wide transition-colors group-hover:text-specialprojectsection"
          >
            {{ wiki.title }}
          </div>
        </div>
      </NuxtLink>
    </div>

    <div v-else class="text-gray-500 mt-10 text-center">
      Нет доступных рекомендаций
    </div>

    <BaseThePagination :entity="wikis" />
  </div>
</template>

<script setup>
const router = useRouter();
const route = useRoute();

const sortOptions = [
  { label: 'Все', value: '' },
  { label: 'Новые', value: 'last' },
  { label: 'Выбор читателей', value: 'select_reader' },
  { label: 'Статьи недели', value: 'select_redaction' },
];

const activeTab = computed({
  get: () => route.query.sort || '',
  set: (val) => {
    const query = { ...route.query };

    if (!val) {
      delete query.sort;
    } else {
      query.sort = val;
    }

    delete query.page;

    router.push({
      path: route.path,
      query,
    });
  },
});

const { wikis } = useWikis({
  per_page: 12,
  filters: computed(() => ({
    category: null,
    period: null,
    search: '',
    sort: route.query.sort || '',
  })),
  page: computed(() => Number(route.query.page) || 1),
  isMainPage: false,
});

const wikisData = computed(() => wikis.data.value?.data || []);
</script>
